<template>
  <div class="boxPop">
      <van-popup v-model="show" closeable @click-close-icon="closedCha" :close-on-click-overlay="false">
        <div class="popCenter">
          <ul>
            <li
              :class="[{ active: item.select }]"
              v-for="(item, index) in chooseList"
              :key="index"
              @click="changeAlgorithm(item)"
            >
              {{ item.tit }}
            </li>
          </ul>

          <div class="closeEnter" @click="createImg">生成图片</div>
        </div>
      </van-popup>

    <ShareReport
      v-if="showShare"
      :startTime="startTime"
      :endTime="endTime"
      :titleInfo="titleInfo"
      :answerTitinfo="answerTitinfo"
      :answerData="answerData"
      :pingjunTitinfo="pingjunTitinfo"
      :pingjunData="pingjunData"
      :fenximathTitinfo="fenximathTitinfo"
      :fenxienglishTitinfo="fenxienglishTitinfo"
      :fenximathData="fenximathData"
      :fenxienglishData="fenxienglishData"
      :chooseList="chooseList"
      @haibaopopClose="haibaopopClose"
    />
  </div>
</template>
<script>
import ShareReport from '../shareReport.vue';
export default {
  props: {
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
    titleInfo: {
      type: Object,
      default: () => {},
    },
    answerTitinfo: {
      type: Object,
      default: () => {},
    },
    pingjunTitinfo: {
      type: Object,
      default: () => {},
    },
    fenximathTitinfo: {
      type: Object,
      default: () => {},
    },
    fenxienglishTitinfo: {
      type: Object,
      default: () => {},
    },
    answerData: {
      type: Array,
      default: () => [],
    },
    pingjunData: {
      type: Array,
      default: () => [],
    },
    fenximathData: {
      type: Array,
      default: () => [],
    },
    fenxienglishData: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ShareReport,
  },
  data() {
    return {
      showShare: false, //海报
      show: true,
      chooseList: [
        { id: 0, tit: '概况', select: false },
        { id: 1, tit: '答题量分析', select: false },
        { id: 2, tit: '正确率分析', select: false },
      ],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.isExist();
  },
  methods: {
    closedCha(){
      this.$emit('selectsharepopClose');
    },
    haibaopopClose() {
      this.$emit('selectsharepopClose');
    },

    changeAlgorithm(item) {
      this.$set(item, 'select', !item.select);
    },
    //是否存在数学或者英语考点分析
    isExist() {
      let math = [];
      let english = [];
      if (this.fenximathData.length > 0) {
        math.push({ id: 3, tit: '考点分析-数学', select: false });
      }
      if (this.fenxienglishData.length > 0) {
        english.push({ id: 4, tit: '考点分析-英语', select: false });
      }
      this.chooseList = [...this.chooseList, ...math, ...english];
    },

    createImg() {
      if (this.chooseList.some((item) => item.select === true)) {
        this.showShare = true;
      } else {
        this.$toast('请选择要分享的内容');
      }
    },
  },
};
</script>
<style scoped lang="scss">
.boxPop {
  .popCenter {
    width: 634px;
    padding-bottom: 50px;
    background: #ffffff;
    border-radius: 14px;
    ul {
      width: 100%;
      padding: 36px 40px;
      display: flex;
      flex-wrap: wrap;
      li {
        width: 243px;
        height: 58px;
        line-height: 58px;
        background: #f1f2f6;
        border-radius: 29px;
        text-align: center;
        font-size: 25px;
        font-weight: 400;
        color: #333333;
        margin: 15px 11px;
        border: 2px solid #f1f2f6;
      }
      .active {
        background: #fff;
        border: 2px solid #ff7f41;
        color: #ff7f41;
      }
    }
    .closeEnter {
      width: 418px;
      height: 80px;
      background: #ff7f41;
      border-radius: 40px;
      text-align: center;
      font-size: 29px;
      font-weight: 500;
      color: #ffffff;
      line-height: 80px;
      margin: 0 auto;
    }
  }
  ::v-deep .van-popup {
    border-radius: 8px;
  }
  ::v-deep .van-icon-cross:before {
    color: #333;
  }
}
</style>
